// Argus — ArgusToolbar: toolbar reusable slim + theme-aware folosit cross-app.
// Style unificat: height 40px, padding inline 1, divider bottom subtil, fără tentă gri stătătoare.

import { Box, type SxProps, type Theme } from '@mui/material';
import type { ReactNode } from 'react';

export interface ArgusToolbarProps {
  children: ReactNode;
  /** Variantă vizuală — primary (default) folosește background.paper, accent folosește primary.dark.  */
  variant?: 'primary' | 'accent';
  /** Padding inline (default 1). */
  px?: number;
  /** Border bottom (default true). */
  divider?: boolean;
  /** Sx adițional. */
  sx?: SxProps<Theme>;
}

const TOOLBAR_HEIGHT = 40;

export function ArgusToolbar({
  children,
  variant = 'primary',
  px = 1,
  divider = true,
  sx,
}: ArgusToolbarProps): JSX.Element {
  const baseSx: SxProps<Theme> = {
    minHeight: TOOLBAR_HEIGHT,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 0.75,
    px,
    py: 0.5,
    backgroundColor: variant === 'accent' ? 'primary.dark' : 'background.paper',
    color: variant === 'accent' ? 'primary.contrastText' : 'text.primary',
    borderBottom: divider ? 1 : 0,
    borderColor: 'divider',
    flexShrink: 0,
  };

  return <Box sx={{ ...baseSx, ...(sx ?? {}) }}>{children}</Box>;
}

export const TOOLBAR_HEIGHT_PX = TOOLBAR_HEIGHT;
